export default __webpack_public_path__ + "static/media/payment-card.e359e3b8.svg";